import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../../data/site';

export const ServicesSection = () => (
  <section data-testid="services-section" className="py-24 lg:py-32 bg-stone border-y border-clay">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
        <div>
          <p className="text-[10px] tracking-[0.3em] text-terra font-medium mb-4">CHAPTER 01 — WHAT WE BUILD</p>
          <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-ink">
            Featured<br />Services
          </h2>
        </div>
        <Link to="/services" data-testid="services-view-all-link"
          className="group text-[11px] tracking-[0.2em] font-medium text-ink flex items-center gap-2 w-max hover:text-terra transition-colors duration-300">
          ALL SERVICES <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-clay border border-clay">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
            className="group relative p-8 lg:p-10 bg-sand hover:bg-moss transition-colors duration-500 min-h-[260px] flex flex-col"
            data-testid={`service-card-${s.num}`}
          >
            <span className="font-serif italic text-3xl text-terra">{s.num}</span>
            <h3 className="mt-auto font-heading font-bold text-2xl tracking-tight text-ink group-hover:text-sand transition-colors duration-500">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/60 group-hover:text-sand/70 transition-colors duration-500">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
